import { useState, useMemo, Fragment } from "react"
import { getIn, useFormikContext } from "formik"
import * as Yup from 'yup'
import { showDate } from "../../../../../../components/helpers"

import { FormikFileUpload, ApplicationFileDownload, FormikNotesArea } from "../../../../../../components/widgets"
import { useDLMResponseFormContext } from "../../components"
import { IWebFileAttachment } from "../../../../../core/applications"

export interface IDLMSubmitROI  {
  verdict: string,
  workflow: string,
  note: string,
  noteAttachments: Array<IWebFileAttachment>
  siteROIModels: Array<any>
}

export const initDLMSubmitROIValues: IDLMSubmitROI = {
  verdict: '',
  workflow: '',
  note: '',
  noteAttachments: [],  
  siteROIModels: []
}

export const DLMSubmitROISchema: any = Yup.object({
  verdict: Yup.string().trim(),
  workflow: Yup.string().trim(),
  note: Yup.string().trim().label('Note')
  .when('verdict', {
    is : (verdict: string) => (verdict === 'rejected'),
    then: (schema) => schema.required(),
  }),
  noteAttachments: Yup.array(),

  siteROIModels: Yup.array().of(
  Yup.object().shape({
    siteID: Yup.number().integer(),
    projectName: Yup.string().trim(),
    clientRefNo: Yup.string().trim(),
    roiModels: Yup.array().of(
      Yup.object().shape({
        roiId: Yup.number().integer().label('ROI Id'),
        roiAttachmentId: Yup.number().integer().integer().moreThan(0,'ROI required').required().label('ROI Attachment'),
        roiAttachmentIdAttachmentName: Yup.string().trim(),
      })
    )
  })
  )
});

export const DLMSubmitROIForm = () => {

  const [ siteIndex ] = useState(0);
  const { values, validateField, setFieldValue } = useFormikContext();
  const { setBaseROI, setGenROIIndex, generateROI, setOnGenROI, appState } = useDLMResponseFormContext();


  const { siteId, workflow, rois } = useMemo(() => {

  if (! values)  return { siteId: 0, workflow: '', rois: [] };

    const siteROIModels = getIn(values, 'siteROIModels');
    const workflow = getIn(values, 'workflow');

    if (! (siteROIModels && siteIndex < siteROIModels.length)) {
      return { siteId: null, projectName: '', clientRefNo: '', rois: [] }
    }

    const { siteId, roiModels: rois } = siteROIModels[siteIndex];
    return { siteId, workflow, rois };
  }, [values, siteIndex]);

  const updateROI = (retvals: any, genROIIndex: number) => {

    if (! (retvals && genROIIndex > -1)) return;

    const _fldname = `siteROIModels.${siteIndex}.roiModels.${genROIIndex}`;
    const _roi = getIn(values, _fldname);
    if (! _roi) return;

    setFieldValue(_fldname, { ..._roi, ...retvals}, true);
    validateField(`siteROIModels.${siteIndex}.roiModels`);
  }

  return (
  <>
  { siteId &&
  <>
  <h4 className="mt-4">Upload ROI</h4>
  { (! ((workflow === 'Label5' || workflow === 'LabelReplace' || workflow === 'ROIEdit'|| workflow === 'ROISplit') && (appState === 'ROI Pending SCDF Verification'))) &&
  <div className='text-muted fs-7'>For COC Holder Endorsement</div>
  }
  <div className='separator border-gray-200 mb-2'></div>
  <div className="row mb-4">
  { (rois && rois.length > 0) && rois.map((roi: any , idx : number) => (
  <Fragment key={`roi_upload${idx}`}>
    <div className="col-5">
    { (appState === 'ROI Pending SCDF Verification') ?
    <>
    { (roi?.signedROIFile) &&
    <>
    <div className="text-muted fs-7">Signed ROI</div>
    <ApplicationFileDownload file={roi.signedROIFile} />
    </>
    }
    </>
    :
    <button
        type="button"
        className='btn btn-sm btn-light-secondary py-1 mb-1 px-3'
        onClick={() => {
          setBaseROI(roi);
          setGenROIIndex(idx);
          setOnGenROI(() => updateROI);
          generateROI(true);
        }}
    >
        <span className='indicator-label'>Generate ROI</span>
    </button>
    }
    </div>
    <FormikFileUpload
      size="7"
      label={`[${roi.cbRef}] ${roi.projectName} ${getIn(values, `siteROIModels.${siteIndex}.roiModels.${idx}.issueDate`) ? showDate(getIn(values, `siteROIModels.${siteIndex}.roiModels.${idx}.issueDate`), 'dateOnly') : ''}`}
      name={`siteROIModels.${siteIndex}.roiModels.${idx}.roiAttachmentId`}
      acceptFiles="UserFileFormats"
      disabled={roi?.issueDate ? false : true}
      subTitle={roi?.issueDate ? "Upload ROI here" : "Generate ROI first."}
      required={true}
      onUpdateFunc={() => {
        setTimeout(() => {
          validateField(`siteROIModels`);
        }, 100)
      }}
    />
  </Fragment>
  ))
  }
  </div>
  </>
  }

  <FormikNotesArea required />
  </>
  )
}